import { IOrganizationType } from '../interfaces';

export class OrganizationTypeEntity implements IOrganizationType {
  code: string;
  definition: string;
  display: string;

  constructor(init?: Partial<OrganizationTypeEntity>) {
    Object.assign(this, init);
  }
}
